// extracted by mini-css-extract-plugin
export var deleteIcon = "_r1-5";
export var deleteOption = "_r1-3";
export var divider = "_r1-2";
export var downloadIcon = "_r1-4";
export var drawer = "_r1-0";
export var drawerFooter = "_r1-6";
export var drawerOpen = "_r1-1";
export var highlighted = "_r1-7";
export var lighterHighlight = "_r1-8";